module.exports = __webpack_public_path__ + "static/freightservicemap.ab5ed268.webp";